'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding-right: 15px;\n  width: 100%;\n'], ['\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding-right: 15px;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  &:hover {\n    background-color: rgba(\n      ', '\n    );\n  }\n  &:active {\n    background-color: rgba(\n      ', '\n    );\n  }\n'], ['\n  &:hover {\n    background-color: rgba(\n      ', '\n    );\n  }\n  &:active {\n    background-color: rgba(\n      ', '\n    );\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _icons = require('icons/icons');

var icons = _interopRequireWildcard(_icons);

var _WidgetHeaderButton = require('../WidgetHeaderButton');

var _WidgetHeaderButton2 = _interopRequireDefault(_WidgetHeaderButton);

var _color = require('../util/color');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HeaderWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'ThreadListHeader__HeaderWrapper'
})(_templateObject);

var NewThreadButton = (0, _styledComponents2.default)(_WidgetHeaderButton2.default).withConfig({
  displayName: 'ThreadListHeader__NewThreadButton'
})(_templateObject2, function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return (0, _color.hexToRgba)(backgroundColor, 0.1);
}, function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return (0, _color.hexToRgba)(backgroundColor, 0.4);
});

var HEADER_BUTTON_STYLE = {
  borderRadius: 2,
  fontSize: 20,
  textAlign: 'center',
  transition: 'all 0.5s ease',
  width: 38
};

var ThreadListHeader = function (_React$PureComponent) {
  _inherits(ThreadListHeader, _React$PureComponent);

  function ThreadListHeader() {
    _classCallCheck(this, ThreadListHeader);

    return _possibleConstructorReturn(this, (ThreadListHeader.__proto__ || Object.getPrototypeOf(ThreadListHeader)).apply(this, arguments));
  }

  _createClass(ThreadListHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          mobile = _props.mobile,
          textColor = _props.textColor;

      return _react2.default.createElement(
        HeaderWrapper,
        { className: (0, _classNames2.default)({ mobile: mobile }) },
        _react2.default.createElement(
          'h4',
          {
            style: { textAlign: 'center', color: textColor },
            className: 'm-bottom-0'
          },
          _react2.default.createElement(_FormattedMessage2.default, { message: 'conversations-visitor-experience-components.visitorWidget.header.threadListTitle' })
        ),
        _react2.default.createElement(NewThreadButton, {
          ariaLabel: _I18n2.default.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.createNewThread'),
          backgroundColor: textColor,
          className: 'selenium-test-marker-new-thread-button p-all-2',
          color: this.props.textColor,
          iconName: icons.DESCRIPTION,
          onClick: this.props.createNewThread,
          style: HEADER_BUTTON_STYLE
        })
      );
    }
  }]);

  return ThreadListHeader;
}(_react2.default.PureComponent);

ThreadListHeader.protoTypes = {
  createNewThread: _react.PropTypes.func.isRequired,
  mobile: _react.PropTypes.bool.isRequired,
  textColor: _react.PropTypes.string.isRequired
};

ThreadListHeader.defaultProps = {
  mobile: false,
  textColor: _colors.OLAF
};

exports.default = ThreadListHeader;
module.exports = exports['default'];